import { render } from "./WidgetLikesAndCommentsCounter.vue?vue&type=template&id=33603ea6&ts=true"
import script from "./WidgetLikesAndCommentsCounter.vue?vue&type=script&lang=ts"
export * from "./WidgetLikesAndCommentsCounter.vue?vue&type=script&lang=ts"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__